
import { useState, useEffect, useContext } from 'react';
import axios from 'axios';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

import CustomButton from '../../components/customButton';
import { UserContext } from '../../context/user-context'

export default function Profile() {
  const [loading, setLoading] = useState(false);
  const [profileData, setProfileData] = useState({});
  const [bio, setBio] = useState('');
  const { userToken, user } = useContext(UserContext);
  
  useEffect(() => {
    getProfileData();
  }, []);

  const getProfileData = () => {
    axios.get(process.env.REACT_APP_API_BASE_URL + `/wp-json/gnetwork/v2/members/${user?.ID}`, {
      headers: {
        'Authorization': 'Basic ' + btoa(user?.user_login + ":" + userToken),
        'Content-Type': 'multipart/form-data'
      }
    }).then((res) => {
      // console.log(res.data.data);
      if (res.data.data.description) {
        setBio(res.data.data.description)
      }
      setLoading(false);
    }).catch(err=>{
      console.error(err.message);
      alert('Error! Check Logs.');
      setLoading(false);
    });
  }

  const saveProfileInfo = () => {
    setLoading(true);
    const updateProfileForm = new FormData()
    updateProfileForm.set('bio', 'bio')
    updateProfileForm.set('instagram', 'instagram')

    axios.put(process.env.REACT_APP_API_BASE_URL + '/wp-json/app/v1/members', updateProfileForm, {
      headers: {
        'Authorization': 'Basic ' + btoa(user.user_login + ":" + userToken),
        'Content-Type': 'multipart/form-data'
      }
    }).then(res=>{
      console.log(res.data);
      alert('Success!!.');
      setLoading(false);
    }).catch(err=>{
      console.error(err.message);
      alert('Error!! Check Logs.');
      setLoading(false);
    })
  }

  return (
    <section className="title-container">
      <Container>
        <h2>Profile Info</h2>
        <Row>
          <Col>
            <a 
              href={'https://gnetworkclub.com/member/' + user?.user_login} 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-primary w-100"
            >View Profile</a>
            <Form onSubmit={saveProfileInfo}>
              <Form.Group className="mb-3" controlId="formBasicBio">
                <Form.Label>Bio</Form.Label>
                <Form.Control as="textarea" rows={6} value={bio} onKeyUp={(event) => {
                  setBio(event.target.value);
                }}/>
              </Form.Group>
              <CustomButton type="submit" color="green" text={!loading ? 'Save Info' : 'Saving...'} className="login-button"/>
            </Form>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
